import { useState } from "react";
import PlanPrecioNuevo from "./PlanPrecioNuevoModal"
import PlanesListado from "./PlanListado";
import PlanEditarModal from "./PlanEditarModal";
import usePermissions from "../../../hook/usePermissions";
import Boton from "../../UI/Boton";
import { IconoMas } from "../../UI/Iconos";

export default function Plan() {
    // RBAC-CUTOVER-07: Crear depende de planes.create (backend ya lo exige
    // en planes.routes.ts); Editar/Eliminar se gatean dentro de PlanListado.js.
    const { hasPermission } = usePermissions();
    const [reloadPromociones, setReloadPromociones] = useState(false);
    const [showPlanNuevo, setShowPlanNuevo] = useState(false);
    const [planSeleccionado, setPlanSeleccionado] = useState(null); // 👈 AÑADE ESTA LÍNEA
    const [planEditando, setPlanEditando] = useState(null);

    const handlePlanNuevo = () => {
        setShowPlanNuevo(!showPlanNuevo);
        if (showPlanNuevo) {
            setReloadPromociones(prev => !prev);
        }
    }

    const handleEditarPlan = (plan) => {
        setPlanEditando(plan);
    };

    return (
        <section>
            {hasPermission("planes.create") && (
                <div className="d-flex justify-content-end mb-3">
                    <Boton variante="primario" icono={IconoMas} onClick={handlePlanNuevo} data-testid="plan-crear">
                        Crear Plan
                    </Boton>
                </div>
            )}

            <PlanesListado data={{ reloadPromociones, onEditarPlan: handleEditarPlan }} />

            <PlanPrecioNuevo
                data={{
                    show: showPlanNuevo,
                    handleClose: handlePlanNuevo,
                    planSeleccionado: planSeleccionado, // 👈 PASA EL PLAN A EDITAR
                }}
            />

            <PlanEditarModal
                show={!!planEditando}
                handleClose={() => setPlanEditando(null)}
                planSeleccionado={planEditando}
                reload={() => setReloadPromociones(prev => !prev)}
            />



        </section>
    )
}